import { ChangeDetectionStrategy, Component, Input, input } from '@angular/core';

import { BoxComponent } from '../common/box/box.component';
import { PlaceloaderComponent } from '../common/placeloader/placeloader.component';

@Component({
  selector: 'rt-box-placeloader',
  templateUrl: 'box-placeloader.component.html',
  styleUrls: ['box-placeloader.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    '[class.stacked]': 'stacked()',
  },
  imports: [BoxComponent, PlaceloaderComponent],
})
export class BoxPlaceloaderComponent {
  public readonly onlyOnePlaceloader = input<boolean>(false);
  public readonly stacked = input<boolean>(undefined!);
  @Input() public height: number = 0;
}
